import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import Tabs from "../../components/Tabs";
import Header from "../../components/Header/NewHeader";
import { getAffiliateInfo } from "../../store/middleware";
import SideMenu from "../../components/SideMenu/SideMenu";
import Contracts from "../../components/affiliates/Contracts";
import SalesLink from "../../components/affiliates/SalesLink";
import PersonalInfo from "../../components/affiliates/PersonalInfo";
import Productivity from "../../components/affiliates/Productivity";
import Transactions from "../../components/affiliates/Transactions";
import { setAffiliateInfo } from "../../store/slices/affiliate.slice";
import affiliateIcon from "../../assets/images/icons/icon_affiliate_header.svg";

function DetailAffiliate() {
  const { id } = useParams();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { affiliateInfo } = useSelector((state) => state.affiliateReducer);

  const [activeTab, setActiveTab] = useState("PERSONAL_INFO");

  const options = ["PERSONAL_INFO", "PRODUCTIVITY", "SALES_LINK", "TRANSACTIONS", "CONTRACTS"];

  const getData = async () => {
    dispatch(setAffiliateInfo([]));
    await dispatch(getAffiliateInfo(id));
  };

  useEffect(() => {
    getData();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="view">
      <SideMenu />
      <section>
        <Header t={t} title="Affiliates" icon={<img src={affiliateIcon} alt="affiliateIcon" />} typeIcon="custom" />

        <Tabs options={options} activeTab={activeTab} setActiveTab={setActiveTab}>
          {Object.values(affiliateInfo).length > 0 && (
            <>
              {options[0] === activeTab && <PersonalInfo />}
              {options[1] === activeTab && <Productivity setActiveTab={setActiveTab} />}
              {options[2] === activeTab && <SalesLink setActiveTab={setActiveTab} />}
              {options[3] === activeTab && <Transactions />}
              {options[4] === activeTab && <Contracts setShowTaxInformation={() => false} />}
            </>
          )}
        </Tabs>
      </section>
    </div>
  );
}

export default DetailAffiliate;
